import type {
	UserLoan,
	UserDraft,
	LoanRole,
} from '@matech/thebigpos-sdk'

import type { UserRole } from '@/types'
import { concatStrings } from '@/services/helpers'

const mapLoanUserOrUserDraftToUserRole = (
	data: UserLoan | UserDraft,
	assignedRole?: LoanRole
) => {
	const { user, role } = data

	return {
		user: {
			id: user.id,
			name: concatStrings(user.firstName, user.lastName).getValue(),
			email: user.email,
			createdAt: user.createdAt!,
			role: user.role,
			shared: true,
		},
		assignedRole: assignedRole ?? role,
	} as UserRole
}

export default mapLoanUserOrUserDraftToUserRole
